import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import jeansImgW from "../../img/jeans.png";
import jeansImg from "../../img/DirectOrder.jpg";
import direct_order_image from "../../img/direct_order_image.jpg";

interface Props {}

export const DirectOrderCarousel = (props: Props) => {
  const responsive = {
    0: { items: 1 },
    1024: { items: 1 },
  };

  const items = [
    /*     <img src={jeansImg} />,
     */ <img src={direct_order_image} />,
    // <img src={jeansImgW} />
  ];
  return (
    <AliceCarousel
      autoPlay={true}
      autoPlayInterval={50000}
      infinite={true}
      disableButtonsControls={true}
      items={items}
      disableDotsControls={true}
      responsive={responsive}
    />
  );
};
